import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from '../paginas/main';
import QuemSomos from '../paginas/quem_somos';
import NossasLojas from '../paginas/nossas_lojas';
import FAQ from '../paginas/faq';
import ConsertoRelogio from '../paginas/conserto_relogio';
import CopiaChaves from '../paginas/copia_chave';
import AssistenciaCelular from '../paginas/assistencia_celular';
import GravacaoLaser from '../paginas/gravacao_laser';
import ReparoOculos from '../paginas/reparo_oculos';
import ConfeccaoCarimbos from '../paginas/confeccao_carimbo';
import ScrollToTop from '../componentes/scroll_to_top';
import ServicosJoias from '../paginas/joias';
import ServicosAfiacao from '../paginas/afiacao';
import ServicosGravacaoManual from '../paginas/gravacao_manual';
import ServicosEletronicos from '../paginas/eletronicos';
import TrabalheNos from '../paginas/trabalhe_nos';
import AcessorioCelular from '../paginas/acessorio_celular';
import ChaveAcessorios from '../paginas/chave_acessorios';
import Cozinha from '../paginas/cozinha';
import Comunicacao from '../paginas/comunicacao';
import Ferramentas from '../paginas/ferramentas';
import Informatica from '../paginas/informatica';
import OculosAcessorios from '../paginas/oculos_acessorios';
import RelogiosAcessorios from '../paginas/relogio_acessorio';
import CarimboAcessorios from '../paginas/carimbo_acessorios';
import JoiasAcessorios from '../paginas/joias_acessorios';
import Decoracao from '../paginas/decoracao';
import TrincoMais from '../paginas/trinco_mais';
import FaleConosco from '../paginas/fale_conosco';
import Tabacaria from '../paginas/tabacaria';
import Camping from '../paginas/camping.';
import Baterias from '../paginas/baterias';
import Pilhas from '../paginas/pilhas';
import Higiene from '../paginas/higiene';
import Cutelaria from '../paginas/cutelaria';
import Jogos from '../paginas/jogos';
import Instrumentos from '../paginas/instrumentos';
import Presente from '../paginas/presente';
import Papelaria from '../paginas/papelaria';
import Tomadas from '../paginas/tomadas';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const Rotas = () => {

  /* Isso aqui garante que se o cabra não estiver logado, ele é enviado para a tela de login 
  const Private = ({ Item }) => {
    const { codUsuario } = useTrincoContext();
    return (codUsuario && (codUsuario !== '')) ? <Item /> : <Login />;
  };*/

  const RouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
      // Pequeno delay para garantir que o componente da rota 
      // já carregou e alterou o document.title
      setTimeout(() => {
        ReactGA.send({
          hitType: "pageview",
          page: location.pathname + location.search,
          title: document.title // Envia o título atual da aba
        });
      }, 100);
    }, [location]);

    return null;
  };

  return (
    <>
      <BrowserRouter>
        <RouteTracker />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/quem_somos" element={<QuemSomos />} />
          <Route path="/produto_celular" element={<AcessorioCelular />} />
          <Route path="/produto_chaves" element={<ChaveAcessorios />} />
          <Route path="/fale_conosco" element={<FaleConosco />} />
          <Route path="/produto_utensilios" element={<Cozinha />} />
          <Route path="/produto_sinal" element={<Comunicacao />} />
          <Route path="/produto_informatica" element={<Informatica />} />
          <Route path="/produto_carimbos" element={<CarimboAcessorios />} />
          <Route path="/produto_ferramentas" element={<Ferramentas />} />
          <Route path="/produto_oculos" element={<OculosAcessorios />} />
          <Route path="/produto_relogios" element={<RelogiosAcessorios />} />
          <Route path="/produto_pilhas" element={<Pilhas />} />
          <Route path="/produto_baterias" element={<Baterias />} />
          <Route path="/produto_aventura" element={<Camping />} />
          <Route path="/produto_tabacaria" element={<Tabacaria />} />
          <Route path="/trabalhe_conosco" element={<TrabalheNos />} />
          <Route path="/nossas_lojas" element={<NossasLojas />} />
          <Route path="/trinco_mais" element={<TrincoMais />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/produto_decoracoes" element={<Decoracao />} />
          <Route path="/produto_joias" element={<JoiasAcessorios />} />
          <Route path="/produto_presente" element={<Presente />} />
          <Route path="/produto_escritorio" element={<Papelaria />} />
          <Route path="/produto_jogos" element={<Jogos />} />
          <Route path="/produto_instrumentos" element={<Instrumentos />} />
          <Route path="/produto_cuidados_pessoais" element={<Higiene />} />
          <Route path="/produto_cutelaria" element={<Cutelaria />} />
          <Route path="/produto_tomadas" element={<Tomadas />} />
          <Route path="/servico_relogio" element={<ConsertoRelogio />} />
          <Route path="/servico_chave" element={<CopiaChaves />} />
          <Route path="/servico_celular" element={<AssistenciaCelular />} />
          <Route path="/gravacao_laser" element={<GravacaoLaser />} />
          <Route path="/servico_oculos" element={<ReparoOculos />} />
          <Route path="/servico_carimbos" element={<ConfeccaoCarimbos />} />
          <Route path="/servico_joias" element={<ServicosJoias />} />
          <Route path="/servico_afiacao" element={<ServicosAfiacao />} />
          <Route path="/gravacao_manual" element={<ServicosGravacaoManual />} />
          <Route path="/servico_eletronicos" element={<ServicosEletronicos />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default Rotas;